var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360.77,180.38c0,39.81-12.92,76.58-34.69,106.41l109.79,109.88c10.84,10.84,10.84,28.45,0,39.29-10.84,10.84-28.45,10.84-39.29,0l-109.79-109.88c-29.83,21.85-66.6,34.69-106.41,34.69C80.74,360.77,0,280.03,0,180.38S80.74,0,180.38,0s180.38,80.74,180.38,180.38ZM180.38,305.26c68.97,0,124.88-55.91,124.88-124.88s-55.91-124.88-124.88-124.88-124.88,55.91-124.88,124.88,55.91,124.88,124.88,124.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.e826e98ac0da8adfffe426a507a71e21.svg";
export { ForwardRef as ReactComponent };